import React from "react";

const HairScalpTreatmentBenefits = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Benefits of Our Hair Scalp Treatment</h3>
      <li>
        <h6>Improved Scalp Health:</h6>
        <p>
          Regular treatments can help combat dryness, itchiness, and flakiness.
        </p>
      </li>
      <li>
        <h6> Stimulated Hair Growth:</h6>
        <p>
          By promoting better blood circulation, our treatments encourage
          healthier hair growth.
        </p>
      </li>
      <li>
        <h6> Reduced Hair Fall:</h6>
        <p>Addressing scalp issues can significantly minimize hair shedding.</p>
      </li>
      <li>
        <h6>Enhanced Hair Texture:</h6>
        <p>A healthy scalp leads to smoother, shinier, and stronger hair.</p>
      </li>
      <li>
        <h6> Stress Relief:</h6>
        <p>
          Our relaxing therapies provide a much-needed break from daily
          stressors.
        </p>
      </li>
    </div>
  );
};

export default HairScalpTreatmentBenefits;
